
import { useAuth } from '@/contexts/AuthContext';
import { 
  PersonalityType, 
  CareerPreferences,
  MBTIResult
} from '@/utils/personalityTypes';
import ProgressBar from './personality-test/ProgressBar';
import SectionIndicator from './personality-test/SectionIndicator';
import QuestionCard from './personality-test/QuestionCard';
import CompletionMessage from './personality-test/CompletionMessage';
import { usePersonalityTest } from '@/hooks/usePersonalityTest';

interface PersonalityTestProps {
  onComplete: (result: { 
    personalityType: PersonalityType, 
    careerPreferences: CareerPreferences,
    mbtiResult: MBTIResult 
  }) => void;
}

const PersonalityTest = ({ onComplete }: PersonalityTestProps) => {
  const { isAuthenticated } = useAuth();
  
  const {
    currentQuestionIndex,
    currentQuestion,
    isCompleted,
    isTransitioning,
    progressPercentage,
    mbtiPhase,
    questions,
    handleAnswer
  } = usePersonalityTest({ onComplete, isAuthenticated });
  
  return (
    <div className="w-full max-w-2xl mx-auto px-4">
      {!isCompleted && (
        <>
          <ProgressBar progressPercentage={progressPercentage} />
          
          <SectionIndicator mbtiPhase={mbtiPhase} />
          
          {!isCompleted && currentQuestion && (
            <QuestionCard 
              currentQuestion={currentQuestion}
              currentQuestionIndex={currentQuestionIndex}
              questionsLength={questions.length}
              isTransitioning={isTransitioning}
              handleAnswer={handleAnswer}
            />
          )}
        </>
      )}
      
      {isCompleted && <CompletionMessage />}
    </div>
  );
};

export default PersonalityTest;
